export const IMAGE_ASPECT_RATIO_PRESETS = [
  { value: "1:1", label: "Square (1:1)", width: 1, height: 1 },
  { value: "4:3", label: "Landscape (4:3)", width: 4, height: 3 },
  { value: "3:2", label: "Landscape (3:2)", width: 3, height: 2 },
  { value: "16:9", label: "Widescreen (16:9)", width: 16, height: 9 },
  { value: "21:9", label: "Ultrawide (21:9)", width: 21, height: 9 },
  { value: "3:4", label: "Portrait (3:4)", width: 3, height: 4 },
  { value: "2:3", label: "Portrait (2:3)", width: 2, height: 3 },
] as const;

export const CUSTOM_IMAGE_ASPECT_RATIO = "custom";
export const DEFAULT_IMAGE_ASPECT_RATIO = "16:9";

export type ImageFit = "cover" | "contain";

function normalizeRatioPart(value: unknown, fallback: number): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0
    ? Math.min(10_000, parsed)
    : fallback;
}

export function resolveImageAspectRatio(
  preset: unknown,
  customWidth: unknown = 16,
  customHeight: unknown = 9,
): string {
  if (preset === CUSTOM_IMAGE_ASPECT_RATIO) {
    const width = normalizeRatioPart(customWidth, 16);
    const height = normalizeRatioPart(customHeight, 9);
    return `${width} / ${height}`;
  }

  const selected = IMAGE_ASPECT_RATIO_PRESETS.find(
    (option) => option.value === preset,
  ) ?? IMAGE_ASPECT_RATIO_PRESETS.find(
    (option) => option.value === DEFAULT_IMAGE_ASPECT_RATIO,
  )!;

  return `${selected.width} / ${selected.height}`;
}

export function normalizeImageFit(value: unknown): ImageFit {
  return value === "contain" ? "contain" : "cover";
}

export function normalizeImageFocalPosition(value: unknown): number {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 50;
  return Math.min(100, Math.max(0, parsed));
}
